import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import SummaryContext from '@totem/components/portfolio/overview/summary/summaryContext';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import IBDIcon from '@totem/styles/Icon';
import { isNotNull, isNull } from '@totem/utilities/common';

import './summary.css';

const styles = {
  card: {
    marginTop: '2rem',
    width: '100%',
  },
  cardHeader: {},
  cardBody: {
    overflow: 'scroll',
    height: '34rem',
  },
};

const Regions = () => {
  const { data, selectedRegionIds, setSelectedRegionIds } =
    useContext(SummaryContext);

  return (
    <IBCard
      title={'Regions'}
      extra={
        <Link to={'/dashboard/regions'}>
          <IBDIcon name="Edit" />
        </Link>
      }
      style={styles.card}
      styles={{ body: styles.cardBody }}
    >
      <>
        <div
          onClick={() => setSelectedRegionIds([])}
          styleName={`portfolio-item ${
            isNull(selectedRegionIds) || selectedRegionIds.length === 0
              ? 'selected'
              : ''
          }`}
        >
          Portfolio
        </div>
        {isNotNull(data) &&
          data.map(({ id, name }) => {
            return (
              <React.Fragment key={id}>
                <div
                  onClick={() => setSelectedRegionIds([id])}
                  styleName={`portfolio-item portfolio-indent ${
                    selectedRegionIds.findIndex((chk) => chk === id) >= 0
                      ? 'selected'
                      : ''
                  }`}
                >
                  {name}
                </div>
              </React.Fragment>
            );
          })}
      </>
    </IBCard>
  );
};

export default Regions;
